/* Step 11d-7 · lane D7a (owner answers of 01-Nov-2026) — EN + AR.
   Item 1 (18:31 KSA): a firm on its OWN AI key is never served by the platform key; when its key fails the AI call stops and
     reads "AI unavailable — contact Customer Service" (backend/ai_error_text.py TEXT "own_key_failed", same words) — on every
     screen, job row, bell note, pre-mark batch, Assistant reply and methodology row; the Provider & key card no longer says the
     platform key served the call; a document read stopped by the firm's key names it (b34e.extractReason.own_key).
   Item 5 (16:18 / 16:22): pre-mark runs up to 3 batches at a time (dc.aiBatches.running); a run stopped by the firm's key has
     its own stop line (dc.b34.reason.own_key, dc.aiBatches.ownKeyStopped).
   No provider name in any text here (CLAUDE.md §3). */
export default {
  en: {
    aiErr: {
      own_key_failed: "AI unavailable — contact Customer Service.",
    },
    errors: {
      AI_OWN_KEY_FAILED: "AI unavailable — contact Customer Service.",
    },
    s7e1: {
      aiu: {
        headRuntime: "Your own key failed on a recent AI call — the call was stopped. AI unavailable — contact Customer Service.",
        headSetup: "Your own key cannot be used — AI calls are stopped. AI unavailable — contact Customer Service.",
      },
    },
    b34e: {
      extractReason: {
        own_key: "AI unavailable — contact Customer Service.",
      },
    },
    dc: {
      b34: { reason: { own_key: "AI unavailable — contact Customer Service" } },
      aiBatches: {
        running: "{r} running at once",
        ownKeyStopped: "Stopped — AI unavailable — contact Customer Service. Completed batches are kept; the remaining batches run later with Resume.",
      },
    },
  },
  ar: {
    aiErr: {
      own_key_failed: "الذكاء الاصطناعي غير متاح — يرجى التواصل مع خدمة العملاء.",
    },
    errors: {
      AI_OWN_KEY_FAILED: "الذكاء الاصطناعي غير متاح — يرجى التواصل مع خدمة العملاء.",
    },
    s7e1: {
      aiu: {
        headRuntime: "فشل مفتاحكم الخاص في استدعاء حديث للذكاء الاصطناعي — وأُوقف الاستدعاء. الذكاء الاصطناعي غير متاح — يرجى التواصل مع خدمة العملاء.",
        headSetup: "لا يمكن استخدام مفتاحكم الخاص — أُوقفت استدعاءات الذكاء الاصطناعي. الذكاء الاصطناعي غير متاح — يرجى التواصل مع خدمة العملاء.",
      },
    },
    b34e: {
      extractReason: {
        own_key: "الذكاء الاصطناعي غير متاح — يرجى التواصل مع خدمة العملاء.",
      },
    },
    dc: {
      b34: { reason: { own_key: "الذكاء الاصطناعي غير متاح — يرجى التواصل مع خدمة العملاء" } },
      aiBatches: {
        running: "{r} قيد التشغيل في وقت واحد",
        ownKeyStopped: "توقف — الذكاء الاصطناعي غير متاح — يرجى التواصل مع خدمة العملاء. الدفعات المكتملة محفوظة؛ وتُشغَّل الدفعات المتبقية لاحقًا بزر الاستئناف.",
      },
    },
  },
};
